
import { cloneDeep } from 'lodash'
import { getMenuIdByRoute } from '@/public/utils'
import { TAB_PROPS, ORIGIN_FIELDS, FIELD_PROPS, INNER_FIELD_PROPS } from '../constants'
import { normalizeConfig } from './normalize-table'
const traverseAndTransform = (data, level = 0) => {
  data.forEach((item) => {
    let show = item[FIELD_PROPS.SHOW]
    const child = item[FIELD_PROPS.CHILD]
    if (Array.isArray(child) && child.length) {
      const totalCount = child.length
      const checkedCount = child.filter(f => f[FIELD_PROPS.SHOW]).length
      show = checkedCount === totalCount
      item[INNER_FIELD_PROPS.INDTERMINATE] = checkedCount > 0 && checkedCount < totalCount
      item[INNER_FIELD_PROPS.CHILD] = traverseAndTransform(child, level + 1)
    }
    item[INNER_FIELD_PROPS.SHOW] = show
    if (level === 0) {
      item[INNER_FIELD_PROPS.FIXED] = item[FIELD_PROPS.FIXED]
    }
  })
  return data
}

export const initConfigs = (context, options) => {
  const menu = getMenuIdByRoute(context.$store, context.$route)
  const { items } = options
  const normalizedConfig = normalizeConfig(context)
  let normalizedItems = normalizedConfig ? normalizedConfig.items : cloneDeep(items)
  let ids = []
  normalizedItems = normalizedItems.map(item => {
    ids.push(item[TAB_PROPS.GENERIC_ID])
    item[TAB_PROPS.FIELDS] = traverseAndTransform(item[TAB_PROPS.FIELDS])
    // 初始化保留原始数据做对比，兼容旧版配置
    item[ORIGIN_FIELDS] = item[ORIGIN_FIELDS] || cloneDeep(item[TAB_PROPS.FIELDS])
    return item
  })

  console.log('initConfigs', normalizedItems)
  return {
    menuId: menu && menu.id,
    ids,
    items: normalizedItems
  }
}




// WEBPACK FOOTER //
// ./src/public/components/kye-field-settings/data/init-data.js